import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { URLS } from '../../data/navigation/navigation.data';
import { AnalyticsService } from '../../service/analytics/analytics.service';

@Component( {
  selector: 'app-ext-link',
  templateUrl: './ext-link.component.html',
  styleUrls: [ './ext-link.component.scss' ]
} )
export class ExtLinkComponent {

  @Input() href = environment.clientUrl;
  @Input() target = '_blank';
  @Input() rel = '';
  @Input() website = '';
  @Input() ariaLabel = '';

  @Input() linkClass = '';

  URLS = URLS;

  constructor( private router: Router, private analyticsService: AnalyticsService ) {
    // Intentionally blank
  }

  redirect( event?: Event ) {
    // The anchor exposes a real href for crawlers; routing (interstitial page
    // or new-tab open) is handled here, so suppress the default navigation.
    event?.preventDefault();
    // Record clicks that leave the site (anything not pointing at our own
    // origin) so the dashboard shows which outbound links, marketplaces,
    // social, partner sites, visitors actually follow. `website` is the
    // human label set by the caller; `host` groups by destination domain.
    if ( !this.href.startsWith( environment.clientUrl ) ) {
      this.analyticsService.logEvent( 'Outbound Link Clicked', {
        href: this.href,
        website: this.website,
        host: this.linkHost( this.href ),
        target: this.target,
      } );
    }
    if ( !this.href.startsWith( environment.clientUrl ) && this.target !== '_blank' ) {
      this.router.navigate( [ URLS.external ], {
        queryParams: {
          href: this.href,
          website: this.website,
          info: 'You are about to leave this website. Please remember, don\'t click on unknown links or download unverified software.'
        }
      } );
    } else {
      window.open( this.href, this.target );
    }
  }

  /** Destination host for analytics grouping (e.g. 'plugins.jetbrains.com'),
   *  or '' when the href is not a parseable absolute URL. */
  private linkHost( href: string ): string {
    try {
      return new URL( href ).hostname.replace( /^www\./, '' );
    } catch {
      return '';
    }
  }
}
